/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Button from 'components/common/Button';
import { getCurrencyCode, getMinimumFractionDigits } from 'utils/helpers';

const propTypes = {
  onCancelClick: PropTypes.func,
  onConfirmationClick: PropTypes.func,
  bankAccount: PropTypes.string,
  withdrawalAmount: PropTypes.any,
  mmp: PropTypes.number,
  frequency: PropTypes.element,
  showDelayText: PropTypes.bool,
};

const WithdrawalConfirmation = (props) => (
  <div className="confirmation-block">
    <div className="confirmation-block__content">
      <h3 className="confirmation-block__title">
        <FormattedMessage id="selfservice.withdrawalConfirmation.title" />
      </h3>
      <p className="confirmation-block__amount">
        <FormattedNumber
          style="currency"
          currency={getCurrencyCode()}
          value={props.withdrawalAmount}
          minimumFractionDigits={getMinimumFractionDigits(props.withdrawalAmount, 2)}
          maximumFractionDigits={2}
        />
      </p>
      <p>
        <FormattedMessage
          id="selfservice.withdrawalConfirmation.description"
          values={{
            bank: <strong>{props.bankAccount}</strong>,
          }}
        />
      </p>
      {props.mmp > 0
        && (
        <p>
          {COUNTRY === 'AU'
            ? (
              <FormattedMessage
                id="selfservice.withdrawal.mmp.with_frequency"
                values={{ frequency: props.frequency }}
              />
            )
            : <FormattedMessage id="selfservice.withdrawalConfirmation.mmp" />}
          &nbsp;
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            value={props.mmp}
            minimumFractionDigits={getMinimumFractionDigits(props.mmp, 2)}
            maximumFractionDigits={2}
          />
        </p>
        )}
      {props.showDelayText
        && <FormattedMessage id="selfservice.withdrawalConfirmation.delay" tagName="p" />}
    </div>
    <nav className="confirmation-block__navigation">
      <div className="btn-group">
        <Button btnType="secondary" type="button" onClick={props.onCancelClick}>
          <FormattedMessage id="selfservice.withdrawalConfirmation.cancel" />
        </Button>
        <Button type="button" onClick={props.onConfirmationClick}>
          <FormattedMessage id="selfservice.withdrawalConfirmation.confirm" />
        </Button>
      </div>
    </nav>
  </div>
);

WithdrawalConfirmation.propTypes = propTypes;

export default WithdrawalConfirmation;
